import { RefObject, useState } from 'react';

import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import MediaMethods from '../mediaDataCollector/MediaMethods';

interface SettingsButtonProps {
  playerRef: RefObject<HTMLAudioElement> | RefObject<HTMLVideoElement> | RefObject<any>;
}

function SettingsButton({ playerRef }: SettingsButtonProps) {
  const [toggleMenu, setToggleMenu] = useState<boolean>(false);

  function changePlaybackSpeed(speed: number) {
    MediaMethods.setPlaybackSpeed(playerRef, speed);
  }
  return (
    <div className="media-player-button-settings">
      <button className="media-player-button" onClick={() => setToggleMenu(!toggleMenu)} type="button">
        <FontAwesomeIcon className="media-player-icon" icon={faEllipsisV} />
      </button>
      {toggleMenu && (
        <div className="media-player-play-speed-list">
          <ul className="">
            <li className="media-player-play-speed-list-item" onClick={() => changePlaybackSpeed(2)}>
              2X
            </li>
            <li className="media-player-play-speed-list-item" onClick={() => changePlaybackSpeed(1.75)}>
              1.75X
            </li>
            <li className="media-player-play-speed-list-item" onClick={() => changePlaybackSpeed(1.5)}>
              1.5X
            </li>
            <li className="media-player-play-speed-list-item" onClick={() => changePlaybackSpeed(1.25)}>
              1.25X
            </li>
            <li className="media-player-play-speed-list-item" onClick={() => changePlaybackSpeed(1)}>
              normal
            </li>
            <li className="media-player-play-speed-list-item" onClick={() => changePlaybackSpeed(0.75)}>
              0.75X
            </li>
            <li className="media-player-play-speed-list-item" onClick={() => changePlaybackSpeed(0.5)}>
              0.5X
            </li>
            <li className="media-player-play-speed-list-item" onClick={() => changePlaybackSpeed(0.25)}>
              0.25X
            </li>
          </ul>
        </div>
      )}
    </div>
  );
}

export default SettingsButton;
